import { BookOpen, FolderKanban, History, KeyRound, ListChecks, type LucideIcon, Users } from 'lucide-react';

export interface NavItem {
  label: string;
  path: string;
  icon: LucideIcon;
  /** Hides the link for non-admins. The route itself enforces this too (see RequireAdmin). */
  adminOnly?: boolean;
}

export interface NavSection {
  label: string;
  items: NavItem[];
}

export const NAV_SECTIONS: NavSection[] = [
  {
    label: 'Portfolio',
    items: [
      { label: 'โปรเจกต์ทั้งหมด', path: '/projects', icon: FolderKanban },
      { label: 'งานทั้งหมด', path: '/activities', icon: ListChecks },
      { label: 'ประวัติการแก้ไข', path: '/logs', icon: History },
    ],
  },
  {
    label: 'Integration',
    items: [
      { label: 'API Docs', path: '/api-docs', icon: BookOpen },
      { label: 'API Keys', path: '/api-keys', icon: KeyRound, adminOnly: true },
    ],
  },
  {
    label: 'Management',
    items: [{ label: 'Users & Roles', path: '/users', icon: Users, adminOnly: true }],
  },
];

/** Every nav item regardless of role — used for the topbar's page-title lookup. */
export const ALL_NAV_ITEMS: NavItem[] = NAV_SECTIONS.flatMap((s) => s.items);

export const getVisibleNavSections = (isAdmin: boolean): NavSection[] =>
  NAV_SECTIONS.map((s) => ({ ...s, items: s.items.filter((i) => !i.adminOnly || isAdmin) })).filter((s) => s.items.length > 0);
